const data = {
  id: 1,
  title: 'Listen and tick T or F.',
  subTitle: 'Nghe và chọn đúng hoặc sai.',
  audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/58a9e76f-a12c-48bb-aa00-a5edaaf6ec9e.mp3',
  imageUrl: '',
  questionText: '',
  question: '',
  answers: [
    { answer: 'Tony has two red planes.', isCorrect: false },
  ],

};

export default data;
